import { cloneElement, CSSProperties, isValidElement, ReactNode } from 'react';

import { DragAndDropDesignTokens, getDropPlaceholderStyle } from './platformStyles';

interface MeasuredPlaceholderProps {
    'data-platform-drop-placeholder'?: 'true';
    style?: CSSProperties;
}

/**
 * Decorates a drag engine's measured placeholder without replacing its node.
 * Keeping the engine-owned element preserves its width, height, margins, and
 * flex behavior while giving every sortable surface the platform treatment.
 */
export const decorateDropPlaceholder = (
    placeholder: ReactNode,
    token: DragAndDropDesignTokens,
    style?: CSSProperties,
): ReactNode => {
    if (!isValidElement<MeasuredPlaceholderProps>(placeholder)) {
        return placeholder;
    }

    return cloneElement(placeholder, {
        'data-platform-drop-placeholder': 'true',
        style: getDropPlaceholderStyle(
            {
                ...placeholder.props.style,
                ...style,
            },
            token,
        ),
    });
};
